import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  TemplateRef,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "../../Services/crud.service";
import { LogedInUserService } from "../../Services/loged-in-user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  ModalDismissReasons,
  NgbAccordionConfig,
  NgbModal,
  NgbNavChangeEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { DeleteConfirmationDialogComponent } from "../delete-confirmation-dialog/delete-confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AddEditScreenComponent } from "./add-edit-screen/add-edit-screen.component";
import { FormStateService } from "src/app/Services/form.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { DeactiveConfirmComponent } from "../deactive-confirm/deactive-confirm.component";
import { LoadingService } from "src/app/Services/loading.service";

@Component({
  selector: "app-screen-detail",
  templateUrl: "./screen-detail.component.html",
  standalone: false,
  styles: [
    `
      :host {
        background-color: #ffffff !important;
      }

      .btn-secondary {
        color: #032d55 !important;
      }

      ::ng-deep .mat-mdc-menu-panel {
        min-width: 50px !important;
      }
      .tooltip {
        z-index: 3000 !important;
        position: fixed !important; // prevents it from being clipped by menu overlay
      }
      ::ng-deep .custom-width-modal .modal-dialog {
        width: 50vw;
        max-width: none;
      }
      ::ng-deep .accordion-button {
        background-color: transparent !important;
        box-shadow: none !important; /* Removes default Bootstrap border effect */
      }
      ::ng-deep .swal2-close.custom-swal-close {
        background-color: transparent !important;
        border: none !important;
      }
    `,
  ],
})
export class ScreenDetailComponent implements OnInit {
  currentProject = { id: "", name: "", primaryLanguage: "" };
  totalScreens = null;
  userManagementId: any;
  tooltipGlobalConfig;
  workflowGlobalConfig;
  languageGlobalConfig;
  commonSettingsGlobalConfig;
  globalConfig;
  state = false;
  submitted = false;
  form: UntypedFormGroup;
  showForm = false;
  moduleId: any;
  roleForm: any;
  appRolesdetail: any = [];
  currentModule: any;
  roleData: any;
  screenData = {
    id: "",
    name: "",
    url: "",
    description: "",
    module: "",
    displayOrder: "",
    projectId: "",
    companyId: "",
    roles: "",
  };
  modalRef;
  versionData;
  moduleList = [];
  globalConfigEnable = true;
  globalConfigForm: UntypedFormGroup;
  tooltipConfigForm: UntypedFormGroup;
  workflowConfigForm: UntypedFormGroup;
  languageConfigForm: UntypedFormGroup;
  commonIconConfig: UntypedFormGroup;
  floatVal: any;
  activeTabId = "project-tab-id";
  closeResult = "";
  isLoading = false;
  isDropdownVisible: boolean = false;
  sortField: string = "name";
  sortDirection: string = "asc";
  tooltipsCount = 0;
  workflowCount = 0;
  faqCount = 0;
  isLanguageEnable: boolean = false;
  faqQuestionValue = JSON.stringify({
    color: "#000",
  });
  iconValue = JSON.stringify({
    faicon: "fa-question-circle",
    position: "absolute",
    cursor: "pointer",
    fontSize: "30px",
    background: "transparent",
    padding: "1rem",
    zIndex: "1000",
    transition: "0.3s linear",
    borderRadius: "50px",
  });
  workflowiconValue = JSON.stringify({
    faicon: "fa-map-signs",
    position: "absolute",
    cursor: "pointer",
    fontSize: "30px",
    background: "transparent",
    padding: "1rem",
    zIndex: "1000",
    transition: "0.3s linear",
    borderRadius: "50px",
  });
  languageiconValue = "";
  faqAnswerValue = JSON.stringify({ "background-color": "#F5F7FA" });
  userGuideCSSValue = "";
  iconColor;
  iconColorValue;
  loadingSub;
  versions = [];
  variables = [];
  ugClass = [];
  selectedVersion;
  chartContainer: any;
  projectId;
  activeTab = "project-tab-id";
  selectedVersionId;
  open(content: TemplateRef<any>) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  tabchange(tabName) {
    // Map tabName to hash
    let hash = "";
    switch (tabName) {
      case "project":
      case "project-tab-id":
      case "project&secret-key=myKey":
        hash = "project";
        this.activeTabId = "project-tab-id";
        break;
      case "screen":
      case "screen-tab-id":
        hash = "screen";
        this.activeTabId = "screen-tab-id";
        break;
      case "module":
      case "module-tab-id":
        hash = "module";
        this.activeTabId = "module-tab-id";
        break;
      case "version":
      case "version-tab-id":
        hash = "version";
        this.activeTabId = "version-tab-id";
        break;
      case "variable":
      case "variable-tab-id":
        hash = "variable";
        this.activeTabId = "variable-tab-id";
        break;
      case "custom":
      case "custom-tab-id":
        hash = "custom";
        this.activeTabId = "custom-tab-id";
        break;
      case "role":
      case "role-tab-id":
        hash = "role";
        this.activeTabId = "role-tab-id";
        break;
      case "settings":
      case "settings-tab-id":
        hash = "settings";
        this.activeTabId = "settings-tab-id";
        break;
      default:
        hash = tabName;
        this.activeTabId = tabName;
    }
    if (hash) {
      this.router.navigate([], {
        fragment: hash,
        queryParamsHandling: "preserve",
      });
      this.loadingService.hide();
    }
  }
  ngAfterViewInit() {
    // Set initial tab from hash
    this.setTabFromHash();
    window.addEventListener("hashchange", this.setTabFromHash.bind(this));
  }

  setTabFromHash() {
    const hash = window.location.hash.replace("#", "");
    switch (hash) {
      case "project":
        this.activeTabId = "project-tab-id";
        break;
      case "screen":
        this.activeTabId = "screen-tab-id";
        break;
      case "module":
        this.activeTabId = "module-tab-id";
        break;
      case "version":
        this.activeTabId = "version-tab-id";
        break;
      case "variable":
        this.activeTabId = "variable-tab-id";
        break;
      case "custom":
        this.activeTabId = "custom-tab-id";
        break;
      case "role":
        this.activeTabId = "role-tab-id";
        break;
      case "settings":
        this.activeTabId = "settings-tab-id";
        break;
      default:
        this.activeTabId = "project-tab-id";
    }
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }

  screenId;
  edconfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "yes",
    customClasses: [
      {
        name: "Code",
        class: "code",
      },
      {
        name: "Navigation",
        class: "navigation",
      },
      {
        name: "Icon",
        class: "icon",
      },
      {
        name: "Screenshot",
        class: "screenshot",
      },
      {
        name: "Notes/Tips",
        class: "notes",
      },
    ],
    toolbarHiddenButtons: [["insertImage", "insertVideo"]],
  };

  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private router: Router,
    private modalService: NgbModal,
    private dialog: MatDialog,
    private formStateService: FormStateService,
    private cdr: ChangeDetectorRef,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.route.params.subscribe((params) => {
      let projectId = params["id"];
      this.isLoading = true;
      this.getProjectManagementData = this.getProjectManagementData.bind(this);
      this.getScreenManagement = this.getScreenManagement.bind(this);
      this.getModuleList = this.getModuleList.bind(this);
      this.getTooltips = this.getTooltips.bind(this);
      this.getFAQ = this.getFAQ.bind(this);
      this.getUserGuide = this.getUserGuide.bind(this);
      this.getTooltipGlobalConfig = this.getTooltipGlobalConfig.bind(this);
      this.getWorkflowGlobalConfig = this.getWorkflowGlobalConfig.bind(this);
      this.getLanguageGlobalConfig = this.getLanguageGlobalConfig.bind(this);
      this.getGlobalConfig = this.getGlobalConfig.bind(this);
      setTimeout(() => {
        this.getTooltipGlobalConfig(projectId);
        this.getWorkflowGlobalConfig(projectId);
        this.getLanguageGlobalConfig(projectId);
        this.getGlobalConfig(projectId);
        this.getVersions(projectId);
        this.getProjectManagementData(projectId);
        this.getScreenManagement(projectId);
        this.getModuleList(projectId);
        this.getCommonSettingsGlobalConfig(projectId);
        this.loadingService.hide();
      }, 1500);
    });
  }
  ngOnInit() {
    this.projectId = this.route.snapshot.paramMap.get("id");
    this.activeTabId = "project-tab-id";
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      displayOrder: [
        "",
        [Validators.required, Validators.pattern(/^[1-9]\d*$/)],
      ],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });

    const iconColorValidator = (
      control: AbstractControl
    ): ValidationErrors | null => {
      const iconColor = control.get("iconColor").value;
      const iconColorValue = control.get("iconColorValue");

      if (iconColor && !iconColorValue.value) {
        iconColorValue.setErrors({ required: true });
      } else {
        iconColorValue.setErrors(null);
      }

      return null;
    };
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        this.loadingService.show();
        this.tabchange(fragment);
      }
    });
    this.tooltipConfigForm = this.formBuilder.group(
      {
        hideOn: ["", Validators.required],
        icon: [""],
        showOn: ["", Validators.required],
        iconColor: ["", Validators.required],
        iconColorValue: [""],
      },
      { validators: iconColorValidator }
    );
    this.roleForm = this.formBuilder.group({
      name: ["", [Validators.required, this.noSpacesOrSpecialCharsValidator()]],
      displayname: ["", Validators.required],
    });
    this.tooltipConfigForm.valueChanges.subscribe(() => {
      if (this.tooltipConfigForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });

    this.workflowConfigForm = this.formBuilder.group({
      skipLabel: ["Skip"],
      doneLabel: ["Done"],
      nextLabel: ["Next"],
      prevLabel: ["Back"],
      workflowTimer: ["10"],
      hidePrev: [true],
      exitOnEsc: [true],
      enableFeedback: [false],
      enableRatings: [false],
      exitOnOverlayClick: [""],
      nextPageUrl: ["Next Page"],
      isWorkflowList: [false],
      workfllowListCss: [""],
      elementSelector: [""],
      triggerElement: [""],
      workflowType: ["Dropdown"],
      workfllowIconCss: [""],
    });

    this.workflowConfigForm.valueChanges.subscribe(() => {
      if (this.workflowConfigForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });

    this.languageConfigForm = this.formBuilder.group({
      isLanguageList: [false],
      languageListCss: [""],
      elementSelector: [""],
      triggerElement: [""],
      languageType: ["Dropdown"],
      languageIconCss: [""],
    });

    this.languageConfigForm.valueChanges.subscribe(() => {
      if (this.languageConfigForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });

    this.commonIconConfig = this.formBuilder.group({
      floatValue: ["vFloat"],
      iconVisibility: [""],
    });

    this.commonIconConfig.valueChanges.subscribe(() => {
      if (this.commonIconConfig.dirty) {
        this.formStateService.setFormDirty();
      }
    });

    this.globalConfigForm = this.formBuilder.group({
      isUserGuidance: [""],
      FAQQuestionCSS: [""],
      FAQAnswerCSS: [""],
      enableFeedbackFAQ: [false],
      enableRatingsFAQ: [false],
      enableFeedback: [false],
      enableCopyRight: [false],
      footerText: [""],
      footerCSS: [""],
      enableRatings: [false],
      userGuideClasses: [""],
      elementSelector: [""],
      triggerElement: [""],
      drawerWidth: ["700"],
      IconCSS: [""],
      defaultTemplate: [""],
      enableChatBot: [true],
    });

    this.globalConfigForm.valueChanges.subscribe(() => {
      if (this.globalConfigForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });

    this.languageConfigForm
      .get("isLanguageList")
      ?.valueChanges.subscribe((value: boolean) => {
        this.isLanguageEnable = value;
      });
  }

  onVersionfilterChange(projectId, e) {
    this.loadingService.show();
    this.selectedVersion = e;

    this.getVariables(projectId, e);
    this.getRole(projectId, e);
    this.getUgClass(projectId, e);
    this.loadingService.hide();
  }

  onDropdownVersionChange(projectId, versionValue) {
    let self = this;
    self.totalScreens = [];
    self.logedInUserService.get(function (logedInUser) {
      self.crudService.get(
        null,
        function (response) {
          if (response && response.length) {
            self.totalScreens = response;
            self.totalScreens.forEach((pScreenManagement) => {
              pScreenManagement.count = {
                tooltips: 0,
                workflows: 0,
                faq: 0,
                userGuide: 0,
              };
              self.getTooltips(
                pScreenManagement.id,
                pScreenManagement,
                pScreenManagement.projectId,
                versionValue
              );
              self.getFAQ(
                pScreenManagement.id,
                pScreenManagement,
                pScreenManagement.projectId,
                versionValue
              );
              self.getUserGuide(
                pScreenManagement.id,
                pScreenManagement,
                pScreenManagement.projectId,
                versionValue
              );
              self.getWorkflowsCount(
                pScreenManagement.id,
                pScreenManagement,
                pScreenManagement.projectId,
                versionValue
              );
            });
          } else {
            self.totalScreens = [];
          }
          self.isLoading = false;
        },
        `screenManagements?filter[order]=name ASC&filter[where][companyId]=${logedInUser.companyId}&filter[where][projectId]=${projectId}`
      );
    });
    // this.isLoading = false;
  }
  onTooltipGlobalConfigReset() {
    this.iconColor = "";
    this.iconColorValue = "";
    this.tooltipConfigForm.patchValue(this.tooltipGlobalConfig);
    setTimeout(() => {
      this.tooltipConfigForm.markAsPristine();
      this.formStateService.clearFormDirty();
    }, 1000);
  }

  onGlobalConfigReset() {
    this.globalConfigForm.patchValue(this.globalConfig);
    setTimeout(() => {
      this.globalConfigForm.markAsPristine();
      this.formStateService.clearFormDirty();
    }, 1000);
  }

  onWorkflowGlobalConfigReset() {
    this.workflowConfigForm.patchValue(this.workflowGlobalConfig);
    setTimeout(() => {
      this.workflowConfigForm.markAsPristine();
      this.formStateService.clearFormDirty();
    }, 1000);
  }

  onLanguageGlobalConfigReset() {
    this.languageConfigForm.patchValue(this.languageGlobalConfig);
    setTimeout(() => {
      this.languageConfigForm.markAsPristine();
      this.formStateService.clearFormDirty();
    }, 1000);
  }

  onTooltipGlobalSubmit() {
    var self = this;

    if (this.tooltipConfigForm.invalid) return;

    if (
      this.tooltipConfigForm.value.showOn == "click" &&
      !this.tooltipConfigForm.value.icon
    ) {
      self.toastr.error("Tooltip Icon required", "Invalid Operation");
      return;
    }

    var payload = this.tooltipConfigForm.value;
    payload.id = self.tooltipGlobalConfig.id;
    if (payload.id) {
      self.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Tooltip Global Configuration has been updated successfully.",
              "Success"
            );
          }
          self.tooltipConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
        },
        "tooltipGlobalConfigs"
      );
    } else {
      self.logedInUserService.get(function (logedInUser) {
        payload.companyId = logedInUser.companyId;
        payload.projectManagementId = self.currentProject.id;
        self.crudService.post(
          payload,
          function (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              self.toastr.success(
                "Tooltip Global Configuration has been updated successfully.",
                "Success"
              );
            }
            self.tooltipConfigForm.markAsPristine();
            self.formStateService.clearFormDirty();
          },
          "tooltipGlobalConfigs"
        );
      });
    }
  }

  onWorkflowGlobalSubmit(update) {
    var self = this;

    if (this.workflowConfigForm.invalid) return;

    var payload = this.workflowConfigForm.value;
    if (self.workflowGlobalConfig && self.workflowGlobalConfig.id && update) {
      payload.id = self.workflowGlobalConfig.id;
      this.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Workflow Global Configuration has been updated successfully.",
              "Success"
            );
          }
          self.workflowConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
        },
        "workflow-global-configs"
      );
    } else {
      payload.projectManagementId = this.currentProject.id;
      payload.workfllowIconCss = this.workflowConfigForm.value.workfllowIconCss
        ? this.workflowConfigForm.value.workfllowIconCss
        : self.workflowiconValue;
      this.crudService.post(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Workflow Global Configuration has been created successfully.",
              "Success"
            );

            self.getWorkflowGlobalConfig(payload.projectManagementId);
          }
          self.workflowConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
        },
        "workflow-global-configs"
      );
    }
  }

  onLanguageGlobalSubmit(update) {
    var self = this;

    if (this.languageConfigForm.invalid) return;

    var payload = this.languageConfigForm.value;
    if (self.languageGlobalConfig && self.languageGlobalConfig.id && update) {
      payload.id = self.languageGlobalConfig.id;
      this.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Language Global Configuration has been updated successfully.",
              "Success"
            );
          }
          self.languageConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
        },
        "languageGlobalConfigs"
      );
    } else {
      payload.projectManagementId = this.currentProject.id;
      payload.languageIconCss = this.languageConfigForm.value.workfllowIconCss
        ? this.languageConfigForm.value.workfllowIconCss
        : self.languageiconValue;
      this.crudService.post(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Language Global Configuration has been created successfully.",
              "Success"
            );

            self.getLanguageGlobalConfig(payload.projectManagementId);
          }
          self.languageConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
        },
        "languageGlobalConfigs"
      );
    }
  }

  onCommonIconSettingsSubmit() {
    var self = this;
    if (this.commonIconConfig.invalid) return;
    var payload: any = {
      id: "",
      elementData: { elementVFloat: "", elementHFloat: "", elemenetPath: "" },
      triggerElement: "",
      projectManagementId: this.projectId,
    };

    payload["id"] = this.globalConfig.id;
    if (this.commonIconConfig.value["floatValue"] == "vFloat") {
      payload["elementSelector"] = "VerticalFloat";
      payload["elementData"]["elementVFloat"] = "vFloat";
      payload["elementData"]["elementPath"] = "";
      payload["triggerElement"] = "vFloat";
    } else if (this.commonIconConfig.value["floatValue"] == "hFloat") {
      payload["elementSelector"] = "HorizontalFloat";
      payload["elementData"]["elementVFloat"] = "hFloat";
      payload["elementData"]["elementPath"] = "";
      payload["triggerElement"] = "hFloat";
    } else {
      this.toastr.error("Value is invalid", "Float Value");
    }

    // console.log("payload here for config", payload);

    this.crudService.update(
      payload,
      function (response) {
        // console.log("payload", payload, "response", response);
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          this.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          var payloadForCommonSettings = {};
          payloadForCommonSettings["companyId"] = response.companyId;
          payloadForCommonSettings["projectManagementId"] =
            response.projectManagementId;

          const floatMapping = {
            vFloat: "VerticalFloat",
            hFloat: "HorizontalFloat",
          };

          const authenticatedMapping = {
            authenticated: "authenticated",
            unauthenticated: "unauthenticated",
          };

          const selectedFloat = self.commonIconConfig.value["floatValue"];
          const selectedAuthenticated =
            self.commonIconConfig.value["iconVisibility"];
          if (floatMapping[selectedFloat]) {
            payloadForCommonSettings["floatValue"] =
              floatMapping[selectedFloat];
          }
          if (authenticatedMapping[selectedAuthenticated]) {
            payloadForCommonSettings["iconVisibility"] =
              authenticatedMapping[selectedAuthenticated];
          }

          self.crudService.update(
            payloadForCommonSettings,
            function () {},
            "commonSettings/" +
              response.companyId +
              "/" +
              response.projectManagementId +
              "/updatevalue"
          );
          self.toastr.success(
            "Global Configuration has been updated successfully.",
            "Success"
          );
        }
      },
      "globalConfigs"
    );
  }
  onCommonIconSettingsReset() {
    this.commonIconConfig.reset();
  }
  onGlobalSubmit(update) {
    var self = this;

    if (this.globalConfigForm.invalid) return;

    this.loadingService.show();
    var payload = this.globalConfigForm.value;
    if (self.globalConfig && self.globalConfig.id && update) {
      payload.id = self.globalConfig.id;
      this.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            self.loadingService.hide();
          } else {
            self.toastr.success(
              "Global Configuration has been updated successfully.",
              "Success"
            );
          }
          self.globalConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
          self.loadingService.hide();
        },
        "globalConfigs"
      );
    } else {
      this.loadingService.show();
      payload.FAQQuestionCSS = this.globalConfigForm.value.FAQQuestionCSS
        ? this.globalConfigForm.value.FAQQuestionCSS
        : self.faqQuestionValue;
      payload.IconCSS = this.globalConfigForm.value.IconCSS
        ? this.globalConfigForm.value.IconCSS
        : self.iconValue;
      payload.FAQAnswerCSS = this.globalConfigForm.value.FAQAnswerCSS
        ? this.globalConfigForm.value.FAQAnswerCSS
        : self.faqAnswerValue;
      payload.userGuideClasses = this.globalConfigForm.value.userGuideClasses
        ? this.globalConfigForm.value.userGuideClasses
        : self.userGuideCSSValue;
      payload.projectManagementId = this.currentProject.id;
      this.crudService.post(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.loadingService.hide();
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.loadingService.hide();

            self.toastr.success(
              "Global Configuration has been created successfully.",
              "Success"
            );

            self.getGlobalConfig(payload.projectManagementId);
          }
          self.globalConfigForm.markAsPristine();
          self.formStateService.clearFormDirty();
        },
        "globalConfigs"
      );
    }
  }

  getTooltipGlobalConfig(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.tooltipGlobalConfig = response;
        self.iconColor = self.tooltipGlobalConfig.iconColor;
        self.iconColorValue = self.tooltipGlobalConfig.iconColorValue;
        self.tooltipConfigForm.patchValue(self.tooltipGlobalConfig);
      },
      'tooltipGlobalConfigs/findOne?filter={"where":{"projectManagementId":"' +
        projectId +
        '"}}'
    );
  }

  getWorkflowGlobalConfig(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response, req) {
        if (!response.status) {
          self.workflowGlobalConfig = response;
          self.workflowConfigForm.patchValue(self.workflowGlobalConfig);
          self.workflowiconValue =
            response && response.workfllowIconCss
              ? response.workfllowIconCss
              : self.workflowiconValue;
        }
      },
      'workflow-global-configs/findOne?filter={"where":{"projectManagementId":"' +
        projectId +
        '"}}'
    );
  }

  getLanguageGlobalConfig(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response, req) {
        if (!response.status) {
          self.languageGlobalConfig = response;
          self.languageConfigForm.patchValue(self.languageGlobalConfig);
          self.languageiconValue =
            response && response.languageIconCss
              ? response.languageIconCss
              : self.languageiconValue;
        }
      },
      'languageGlobalConfigs/findOne?filter={"where":{"projectManagementId":"' +
        projectId +
        '"}}'
    );
  }

  getCommonSettingsGlobalConfig(projectId) {
    this.crudService.get(
      null,
      (response, req) => {
        if (!response?.error && response !== null) {
          this.commonSettingsGlobalConfig = response;
          this.commonIconConfig.patchValue(response);

          const floatValue = response.floatValue?.toLowerCase();
          if (floatValue === "verticalfloat" || floatValue === "vfloat") {
            this.commonIconConfig.patchValue({ floatValue: "vFloat" });
          } else if (
            floatValue === "horizontalfloat" ||
            floatValue === "hfloat"
          ) {
            this.commonIconConfig.patchValue({ floatValue: "hFloat" });
          }
        } else {
          const defaultSettings = {
            projectManagementId: projectId,
            floatValue: "vFloat",
            iconVisibility: "unauthenticated",
          };

          this.crudService.post(
            defaultSettings,
            (createResponse) => {
              if (!createResponse.error) {
                this.commonSettingsGlobalConfig = createResponse;
                this.commonIconConfig.patchValue(createResponse);
              } else {
                this.addLogstoFile(createResponse, "commonSettings/create");
              }
            },
            "commonSettings"
          );
        }
      },
      `commonSettings/findOne?filter={"where":{"projectManagementId":"${projectId}"}}`
    );
  }

  getGlobalConfig(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response, req) {
        if (!response.status) {
          self.globalConfig = response;
          self.globalConfig && self.globalConfig.defaultTemplate
            ? ""
            : (self.globalConfig.defaultTemplate = `<h1>Title</h1>
            Some data about page...
            <br>
            <div class="_tas-top4-worflows">
              <h3>Key workflows</h3>
              <table class="_tas-table">
                  <tbody class="_tas-table-body">
                      <tr>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span>
                          </td>
                      </tr>
                      <tr>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            Links and all details of page...
             <br>
            <div class="_tas-all-worflows">
              <h3>All workflows</h3>
              <table class="_tas-table">
                  <tbody class="_tas-table-body">
                      <tr>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span>
                          </td>
                      </tr>
                      <tr>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                          <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>`);
          self.addGlobalCSS();
          self.globalConfigForm.patchValue(self.globalConfig);
          self.iconValue =
            response && response.IconCSS ? response.IconCSS : self.iconValue;
          self.faqQuestionValue =
            response && response.FAQQuestionCSS
              ? response.FAQQuestionCSS
              : self.faqQuestionValue;
          self.faqAnswerValue =
            response && response.FAQAnswerCSS
              ? response.FAQAnswerCSS
              : self.faqAnswerValue;
          self.userGuideCSSValue =
            response && response.userGuideClasses
              ? response.userGuideClasses
              : self.userGuideCSSValue;
        }
      },
      'globalConfigs/findOne?filter={"where":{"projectManagementId":"' +
        projectId +
        '"}}'
    );
  }

  addGlobalCSS() {
    if (this.globalConfig.userGuideClasses) {
      let userGuideClasses = this.globalConfig.userGuideClasses;

      // Ensure that userGuideContent has a unique identifier
      let contentId =
        "editor123 .angular-editor .angular-editor-wrapper .angular-editor-textarea"; // Replace this with the actual ID or class of your element

      // Scope the CSS rules to the userGuideContent element
      let scopedCss = userGuideClasses.replace(
        /([^\}]+)\{/g,
        function (match, selector) {
          // Add the scope only to valid CSS selectors, ignore if already scoped
          return `#${contentId} ${selector.trim()} {`;
        }
      );

      // Create a new <style> element
      let styleElement = document.createElement("style");
      styleElement.type = "text/css";

      // Add the scoped CSS to the <style> element
      styleElement.appendChild(document.createTextNode(scopedCss));

      // Append the <style> element to the document's head
      document.head.appendChild(styleElement);
    }
  }

  getModulesNumber() {
    let self = this;
    let query = `filter[where][projectManagementId]=${this.currentProject.id}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          if (!self.form.value.displayOrder) {
            self.form.patchValue({ displayOrder: response.length + 1 });
          }
        } else {
          self.form.patchValue({ displayOrder: 1 });
        }
      },
      "modules?" + query
    );
  }

  onChange(event) {
    this.form.markAsDirty();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onSubmit() {
    let self = this;
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) return;
    // submit API call
    var payload = this.form.value;
    payload.projectManagementId = this.currentProject.id;

    if (self.moduleId) {
      self.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Module has been updated successfully.",
              "Success"
            );
            self.getModuleList(self.currentProject.id);
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.moduleId = null;
            self.closeModal();
          }
        },
        "modules/" + self.moduleId
      );
    } else {
      self.crudService.post(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "Module has been created successfully.",
              "Success"
            );
            self.getModuleList(self.currentProject.id);
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.closeModal();
          }
        },
        "modules"
      );
    }
  }

  onReset() {
    if (!this.moduleId) {
      this.submitted = false;
      this.form.reset();
    } else {
      this.submitted = false;
      this.form.patchValue(this.currentModule);
    }
    this.formStateService.clearFormDirty();
    this.getModulesNumber();
  }

  toggleForm(moduleManagement: any) {
    this.showForm = !this.showForm;
    if (moduleManagement) {
      this.moduleId = moduleManagement.id;
      this.form.patchValue(moduleManagement);
    }
  }

  getModuleList(projectId) {
    this.loadingService.show();
    let self = this;
    let query = `&filter[where][projectManagementId]=${projectId}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.moduleList = response;
          self.loadingService.hide();
        } else {
          self.moduleList = [];
          self.loadingService.hide();
        }
      },
      `modules?filter[order]=${this.sortField} ${this.sortDirection}${query}`
    );
  }

  opemDeleteConfirmationDialog(id): void {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      width: "600px",
      panelClass: "custom-bg",
      data: {
        title: this.translateService.instant("Form.DeleteModule"),
        paragraph: this.translateService.instant("Form.DeleteModuleMsg"),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Module has been deleted successfully.",
                "Success"
              );
              this.getModuleList(this.currentProject.id);
            }
          },
          "modules/" + id
        );
      }
    });
  }

  createModuleManagement() {
    this.moduleId = undefined;

    this.submitted = false;
    this.form.reset();
    this.showForm = true;
  }

  getProjectManagementData(projectId) {
    // console.log("project management", projectId);
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.currentProject = response;
        self.isLoading = false;
      },
      'projectManagements/findOne?filter={"where":{"id":"' + projectId + '"}}'
    );
  }

  getScreenManagement(projectId) {
    // let self = this;
    this.totalScreens = [];
    this.isLoading = true;
    this.logedInUserService.get((logedInUser) => {
      this.crudService.get(
        null,
        (latestVersion) => {
          this.crudService.get(
            null,
            (response) => {
              if (response && response.length) {
                this.totalScreens = response;

                for (let pScreenManagement of this.totalScreens) {
                  // self.totalScreens.forEach((pScreenManagement) => {
                  pScreenManagement.count = {
                    tooltips: 0,
                    workflows: 0,
                    faq: 0,
                    userGuide: 0,
                  };
                  // console.log("get tooltips");
                  this.getTooltips(
                    pScreenManagement.id,
                    pScreenManagement,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                  this.getFAQ(
                    pScreenManagement.id,
                    pScreenManagement,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                  this.getUserGuide(
                    pScreenManagement.id,
                    pScreenManagement,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                  this.getWorkflowsCount(
                    pScreenManagement.id,
                    pScreenManagement,
                    pScreenManagement.projectId,
                    latestVersion.id
                  );
                }
                this.loadingService.hide();
              } else {
                this.totalScreens = [];
                this.loadingService.hide();
              }
            },
            `screenManagements?filter[order]=name ASC&filter[where][companyId]=${logedInUser.companyId}&filter[where][projectId]=${projectId}`
          );
        },
        "Versions/findOne?filter[order]=created DESC&filter[where][projectManagementId]=" +
          projectId
      );
    });
  }

  getTooltips(screenManagementId, pScreenManagement, projectId, latestVersion) {
    let self = this;
    // console.log("version LATEST SDS", latestVersion);

    this.tooltipsCount = 0;
    let query = `screenManagementId=${screenManagementId}&languageId=${self.currentProject.primaryLanguage}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;

    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          pScreenManagement.count.tooltips = response.length;
          pScreenManagement.tooltipId = response.id;
          self.tooltipsCount += response.length;
        }
      },
      "tooltips/getTooltipsForWebAndPlugin?" + query
    );
  }

  getFAQ(screenManagementId, pScreenManagement, projectId, latestVersion) {
    let self = this;
    self.faqCount = 0;
    let query = `screenManagementId=${screenManagementId}&languageId=${self.currentProject.primaryLanguage}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;
    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          pScreenManagement.count.faq = response.length;
          pScreenManagement.faqId = response.id;
          self.faqCount += response.length;
        }
      },
      "faqs/getFaqsForWebAndPlugin?" + query
    );
  }

  getUserGuide(
    screenManagementId,
    pScreenManagement,
    projectId,
    latestVersion
  ) {
    let self = this;
    let query = `screenManagementId=${screenManagementId}&languageId=${self.currentProject.primaryLanguage}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;

    this.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          pScreenManagement.count.userGuide = response.length;
          pScreenManagement.userGuideId = response.id;
        }
      },
      "userGuides/getUserGuidesForWebAndPlugin?" + query
    );
  }

  getWorkflowsCount(
    screenManagementId,
    pScreenManagement,
    projectId,
    latestVersion
  ) {
    // console.log("screen-detail workflows count called");
    let self = this;
    this.workflowCount = 0;
    let query = `screenManagementId=${screenManagementId}&projectManagementId=${projectId}&projectVersion=${latestVersion}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          pScreenManagement.count.workflows = response.length;
          self.workflowCount += response.length;
        }
      },
      "workflows/getWorkflowsForWebAndPlugin?" + query
    );
    this.workflowCount = self.workflowCount;
  }

  clearScreenData() {
    this.screenData = {
      id: "",
      name: "",
      url: "",
      description: "",
      module: "",
      displayOrder: "",
      projectId: "",
      companyId: "",
      roles: "",
    };
  }
  onTabChange(event: NgbNavChangeEvent) {
    var newTabId = event.nextId;
    var tabId =
      newTabId == "screen-tab-id"
        ? "screen"
        : newTabId == "variable-tab-id"
        ? "dynamic-variable"
        : newTabId == "custom-tab-id"
        ? "custom"
        : newTabId == "module-tab-id"
        ? "module"
        : newTabId == "role-tab-id"
        ? "role"
        : newTabId == "version-tab-id"
        ? "version"
        : "project";
  }
  screenManagement(project, operation, sm?) {
    console.log("[screenManagement] called", { project, operation, sm });

    const modalRef = this.modalService.open(AddEditScreenComponent, {
      size: "lg", // or use width via CSS class
      backdrop: "static", // disable outside click to close
      windowClass: "top-modal custom-width-modal",
    });

    // pass inputs
    modalRef.componentInstance.title = `${sm && sm.id ? "Edit" : "Add"} Screen`;
    if (sm) {
      modalRef.componentInstance.data = sm;
      modalRef.componentInstance.name =
        operation == "new"
          ? this.screenData.name
          : this.screenData.name !== undefined && this.screenData.name != null
          ? this.screenData.name
          : sm && sm.name
          ? sm.name
          : " ";
      modalRef.componentInstance.url =
        operation == "new"
          ? this.screenData.url
          : sm && sm.url
          ? sm.url
          : this.screenData.url;
      modalRef.componentInstance.description =
        operation == "new"
          ? this.screenData.description
          : sm && sm.description
          ? sm.description
          : this.screenData.description;
      modalRef.componentInstance.module =
        operation == "new"
          ? this.screenData.module
          : sm && sm.module
          ? sm.module
          : this.screenData.module;
      modalRef.componentInstance.displayOrder =
        operation == "new"
          ? this.screenData.displayOrder
          : sm && sm.displayOrder
          ? sm.displayOrder
          : this.screenData.displayOrder;
      modalRef.componentInstance.projectId = project.id;
      modalRef.componentInstance.roles = sm?.roles || "";
    }
    // debug the modalRef to ensure it's created correctly
    console.log("[screenManagement] modalRef created", modalRef);

    // handle result (modal.close(value) resolves the promise; dismiss rejects it)
    modalRef.result
      .then((result) => {
        console.log("[screenManagement] modal closed with result:", result);

        // be tolerant — modal may return boolean or object
        const payloadFromModal =
          result && typeof result === "object"
            ? result
            : modalRef.componentInstance?.getResult?.() || result;

        if (!payloadFromModal) {
          console.warn(
            "[screenManagement] no payload returned from modal, aborting"
          );
          return;
        }

        const screenData = {
          id: sm?.id ?? undefined,
          name: payloadFromModal.name ?? "",
          url: payloadFromModal.url ?? "",
          description: payloadFromModal.description ?? "",
          module: payloadFromModal.module ?? "",
          displayOrder: payloadFromModal.displayOrder ?? "",
          projectId: project.id ?? "",
          companyId: project.companyId ?? "",
          roles: payloadFromModal.roles ?? "",
        };

        if (sm?.id) {
          // UPDATE case
          this.crudService.update(
            screenData,
            (response) => {
              if (response.error?.error?.message) {
                this.toastr.error(
                  response.error.error.message,
                  "Invalid Operation"
                );
                this.screenManagement(project, "old", screenData);
              } else {
                this.toastr.success(
                  "Screen has been updated successfully.",
                  "Success"
                );
                this.resetForm();
                this.getScreenManagement(project.id);
              }
            },
            "screenManagements/" + sm.id
          );
        } else {
          // CREATE case
          this.crudService.post(
            screenData,
            (response) => {
              if (response.error?.error?.message) {
                this.toastr.error(
                  response.error.error.message,
                  "Invalid Operation"
                );
                this.screenManagement(project, "old", screenData);
              } else {
                this.toastr.success(
                  "Screen has been created successfully.",
                  "Success"
                );
                this.resetForm();
                this.getScreenManagement(project.id);
              }
            },
            "screenManagements"
          );
        }
      })
      .catch((reason) => {
        // modal dismissed (ESC, backdrop click or explicit dismiss)
        console.log("[screenManagement] modal dismissed:", reason);
      });
  }

  resetForm(): void {
    this.screenData = {
      id: "",
      projectId: "",
      companyId: "",
      name: "",
      url: "",
      description: "",
      module: "",
      displayOrder: "",
      roles: "",
    };
  }

  toggleDisable() {
    if (this.form.disabled) {
      this.form.enable();
    } else {
      this.form.disable();
    }
  }

  openDeleteConfirmationDialog(sm): void {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      width: "600px",
      panelClass: "custom-bg",
      data: {
        title: "Delete Screen",
        paragraph: `${
          sm.count.tooltips > 0 ||
          sm.count.workflows > 0 ||
          sm.count.faq > 0 ||
          sm.count.userGuide > 0
            ? `This will delete ${
                sm.count.tooltips
                  ? `${sm.count.tooltips} ${
                      +sm.count.tooltips == 1 ? "tooltip" : "tooltips"
                    }`
                  : ""
              } ${
                sm.count.workflows
                  ? `${sm.count.workflows} ${
                      +sm.count.workflows == 1 ? "workflow" : "workflows"
                    }`
                  : ""
              } ${
                sm.count.faq
                  ? `${sm.count.faq} ${+sm.count.faq == 1 ? "FAQ" : "FAQs"}`
                  : ""
              } ${
                sm.count.userGuide
                  ? `${sm.count.userGuide} ${
                      +sm.count.userGuide == 1 ? "user guide" : "user guides"
                    }`
                  : ""
              }. `
            : ""
        }Are you sure you want to delete this screen?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Screen has been deleted successfully.",
                "Success"
              );
              this.getScreenManagement(sm.projectId);
            }
          },
          "screenManagements/" + sm.id
        );
      }
    });
  }

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  exportUserGuide(filetype, selectedV) {
    let self = this;
    let query = `projectId=${self.currentProject.id}&filetype=${filetype}`;

    this.isDropdownVisible = false;
    this.crudService.get(
      null,
      function (response) {
        if (response.fileBuffer && response.fileName && response.mimeType) {
          const byteArray = new Uint8Array(response.fileBuffer.data);
          const blob = new Blob([byteArray], { type: response.mimeType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = response.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          this.toastr.error(
            "Unable to download user guide. Please try again later.",
            "Invalid Operation"
          );
        }
      },
      "userGuides/exportUserGuide?" + query
    );
  }

  changeSort(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortField = field;
      this.sortDirection = "asc";
    }
    this.getModuleList(this.currentProject.id);
  }

  getVersions(projectId) {
    const url = `Versions?filter[where][projectManagementId]=${projectId}&filter[order]=created DESC`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          this.versions = response.map((item: any) => item);
          this.onVersionfilterChange(projectId, response[0].id);
        } else {
          this.versions = [];
        }
      },
      url
    );
  }

  getVariables(projectId, selectedVersion) {
    const url = `variables?filter[where][projectManagementId]=${projectId}&filter[order]=created DESC&filter[where][projectVersion]=${selectedVersion}`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          this.variables = response.map((item: any) => item);
        } else {
          this.variables = [];
        }
      },
      url
    );
  }

  getUgClass(projectId, selectedVersion) {
    this.loadingService.show();
    const url = `userGuideClasses?filter[where][projectManagementId]=${projectId}&filter[order]=created DESC&filter[where][projectVersion]=${selectedVersion}`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          this.ugClass = response.map((item: any) => item);
          this.loadingService.hide();
        } else {
          this.ugClass = [];
        }
      },
      url
    );
  }

  onClickOfSaveVariableEditButton(id, key, value, projectVersion) {
    var self = this;
    var payload = {
      key,
      value,
      projectVersion,
      projectManagementId: this.currentProject.id,
    };
    self.crudService.update(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "Variable has been updated successfully.",
            "Success"
          );
          self.getVariables(self.currentProject.id, self.selectedVersion);
        }
      },
      "variables/" + id
    );
  }

  onClickOfSaveVariableButton(key, value, projectVersion) {
    var self = this;
    var payload = {
      key,
      value,
      projectVersion,
      projectManagementId: this.currentProject.id,
    };
    self.crudService.post(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "Variable has been created successfully.",
            "Success"
          );
          self.getVariables(self.currentProject.id, self.selectedVersion);
        }
      },
      "variables"
    );
  }

  onClickOfSaveUGEditClassButton(id, key, value, projectVersion) {
    var self = this;
    var payload = {
      name: key,
      className: value,
      projectVersion,
      projectManagementId: this.currentProject.id,
    };
    self.crudService.update(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "Class for user guide has been updated successfully.",
            "Success"
          );
          self.getUgClass(self.currentProject.id, self.selectedVersion);
        }
      },
      "userGuideClasses/" + id
    );
  }

  onClickOfSaveUGClassButton(key, value, projectVersion) {
    var self = this;
    var payload = {
      name: key,
      className: value,
      projectVersion,
      projectManagementId: this.currentProject.id,
    };
    self.crudService.post(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "Class for The User Guide has been created successfully.",
            "Success"
          );
          self.getUgClass(self.currentProject.id, self.selectedVersion);
        }
      },
      "userGuideClasses"
    );
  }

  onClickOfSaveVersionButton(
    version,
    copyFromDev,
    copyFromQA,
    releaseDate?,
    baseVersion?
  ) {
    var self = this;
    var payload = {
      version,
      releaseDate: releaseDate ? releaseDate : null,
      baseVersion: baseVersion ? baseVersion : "",
      copyFromDev,
      copyFromQA,
      projectManagementId: this.currentProject.id,
      // Add other properties as needed
    };
    self.crudService.post(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "Version has been created successfully.",
            "Success"
          );
          self.getVersions(self.currentProject.id);
        }
      },
      "Versions"
    );
  }

  openVariableEditPopup(item) {
    Swal.fire({
      title:
        '<div class="d-flex justify-content-between ">' +
        '<div class="pull-left" style="text-align: left;">' +
        this.translateService.instant("Form.EditVariable") +
        "</div>" +
        "</div>",
      html:
        '<div style="display: flex;">' +
        '  <span for="_tas-key" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.key") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-key" class="swal2-input" value="' +
        item.key +
        '" placeholder="' +
        this.translateService.instant("Form.EnterKey") +
        '">' +
        '<span id="key-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Key required</span>' +
        '<span id="key-format-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Key must start with a letter and contain only alphanumeric characters without spaces.</span>' +
        "</div>" +
        '<div style="display: flex;">' +
        '  <span for="_tas-value" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.value") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-value" class="swal2-input" value="' +
        item.value +
        '" placeholder="' +
        this.translateService.instant("Form.EnterValue") +
        '">' +
        '<span id="value-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Value required</span>' +
        "</div>" +
        `${
          this.versions.length > 0
            ? '<div style="display: flex; align-items: left;">' +
              '  <span for="_tas-version" style="text-align: left; font-weight:600; font-size:16px">' +
              this.translateService.instant("Form.Version") +
              ":</span>" +
              "</div>" +
              '<div style="display: flex; align-items: left;">' +
              '  <select id="_tas-version" class="swal2-select" style="width: 100%">' +
              this.versions
                .map(
                  (option) =>
                    `<option value='${option.id}' ${
                      option.id == item.projectVersion ? "selected" : ""
                    }>${option.version}</option>`
                )
                .join("") +
              "  </select>" +
              "</div>"
            : ""
        }`,
      confirmButtonText: this.translateService.instant("Form.SAVE"),
      showCancelButton: true,
      showCloseButton: true,

      customClass: {
        popup: "custom-popup-class",
        confirmButton: "swal2-confirm",
      },
      showClass: {
        popup: "animated fadeInLeft faster",
      },
      allowOutsideClick: false,
      onOpen: () => {
        // ✅ Add ID to close buttonlet currentHash = window.location.hash.replace("#", "");

        const closeBtn = document.querySelector(".swal2-close");
        if (closeBtn) {
          closeBtn.setAttribute("id", "close-secretKey-popup");
        }
      },
      preConfirm: () => {
        const keyInput = document.getElementById(
          "_tas-key"
        ) as HTMLInputElement;

        const key = keyInput.value;

        const valueInput = document.getElementById(
          "_tas-value"
        ) as HTMLInputElement;

        const versionSelect = document.getElementById(
          "_tas-version"
        ) as HTMLSelectElement;

        const projectVersion = versionSelect ? versionSelect.value : "";

        const keyError = document.getElementById("key-error");

        const keyFormatError = document.getElementById("key-format-error");

        const valueError = document.getElementById("value-error");

        const value = valueInput.value.trim();

        const keyRegex = /^[A-Za-z][A-Za-z0-9]*$/;

        let isValid = true;

        if (!key) {
          keyError.style.display = "block";
          isValid = false;
        } else {
          keyError.style.display = "none";
        }

        if (key && !keyRegex.test(key)) {
          keyFormatError.style.display = "block";
          isValid = false;
        } else {
          keyFormatError.style.display = "none";
        }

        if (!value) {
          valueError.style.display = "block";
          isValid = false;
        } else {
          valueError.style.display = "none";
        }

        if (!isValid) {
          Swal.showValidationMessage("");
          setTimeout(() => {
            document.getElementById("swal2-validation-message").style.display =
              "none";
          });
        }

        return { key, value, projectVersion };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { key, value, projectVersion } = result.value;

        // Make API call to save the data
        this.onClickOfSaveVariableEditButton(
          item.id,
          key,
          value,
          projectVersion
        );
      }
    });
  }
  openVariablePopup() {
    Swal.fire({
      title:
        '<div class="d-flex justify-content-between ">' +
        '<div class="pull-left" style="text-align: left;">' +
        this.translateService.instant("Form.AddVariable") +
        "</div>" +
        "</div>",
      html:
        '<div style="display: flex;">' +
        '  <span for="_tas-key" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.key") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-key" class="swal2-input" placeholder="' +
        this.translateService.instant("Form.EnterKey") +
        '">' +
        '<span id="key-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Key required</span>' +
        '<span id="key-format-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Key must start with a letter and contain only alphanumeric characters without spaces.</span>' +
        "</div>" +
        '<div style="display: flex;">' +
        '  <span for="_tas-value" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.value") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-value" class="swal2-input" placeholder="' +
        this.translateService.instant("Form.EnterValue") +
        '">' +
        '<span id="value-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Value required</span>' +
        "</div>" +
        `${
          this.versions.length > 0
            ? '<div style="display: flex; align-items: left;">' +
              '  <span for="_tas-version" style="text-align: left; font-weight:600; font-size:16px">' +
              this.translateService.instant("Form.Version") +
              ":</span>" +
              "</div>" +
              '<div style="display: flex; align-items: left;">' +
              '  <select id="_tas-version" class="swal2-select" style="width: 100%">' +
              this.versions
                .map(
                  (option) =>
                    `<option value='${option.id}'>${option.version}</option>`
                )
                .join("") +
              "  </select>" +
              "</div>"
            : ""
        }`,
      confirmButtonText: this.translateService.instant("Form.SAVE"),
      showCancelButton: true,
      showCloseButton: true,

      customClass: {
        popup: "custom-popup-class",
        confirmButton: "swal2-confirm",
      },
      showClass: {
        popup: "animated fadeInLeft faster",
      },
      allowOutsideClick: false,
      preConfirm: () => {
        const keyInput = document.getElementById(
          "_tas-key"
        ) as HTMLInputElement;

        const key = keyInput.value;

        const valueInput = document.getElementById(
          "_tas-value"
        ) as HTMLInputElement;

        const versionSelect = document.getElementById(
          "_tas-version"
        ) as HTMLSelectElement;

        const projectVersion = versionSelect ? versionSelect.value : "";

        const keyError = document.getElementById("key-error");

        const keyFormatError = document.getElementById("key-format-error");

        const valueError = document.getElementById("value-error");

        const value = valueInput.value.trim();

        const keyRegex = /^[A-Za-z][A-Za-z0-9]*$/;

        let isValid = true;

        if (!key) {
          keyError.style.display = "block";
          isValid = false;
        } else {
          keyError.style.display = "none";
        }

        if (key && !keyRegex.test(key)) {
          keyFormatError.style.display = "block";
          isValid = false;
        } else {
          keyFormatError.style.display = "none";
        }

        if (!value) {
          valueError.style.display = "block";
          isValid = false;
        } else {
          valueError.style.display = "none";
        }

        if (!isValid) {
          Swal.showValidationMessage("");
          setTimeout(() => {
            document.getElementById("swal2-validation-message").style.display =
              "none";
          });
        }

        return { key, value, projectVersion };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { key, value, projectVersion } = result.value;

        // Make API call to save the data
        this.onClickOfSaveVariableButton(key, value, projectVersion);
      }
    });
  }

  openUserGuideEditClassPopup(item) {
    Swal.fire({
      title:
        '<div class="d-flex justify-content-between ">' +
        '<div class="pull-left" style="text-align: left;">' +
        this.translateService.instant("Form.EditClassForUserGuide") +
        "</div>" +
        "</div>",
      html:
        '<div style="display: flex;">' +
        '  <span for="_tas-display-name" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.DisplayName") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-display-name" class="swal2-input" value="' +
        item.name +
        '" placeholder="' +
        this.translateService.instant("Form.EnterDisplayName") +
        '">' +
        '<span id="display-name-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Display name required</span>' +
        "</div>" +
        '<div style="display: flex;">' +
        '  <span for="_tas-class-name" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.IconClassValue") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-class-name" class="swal2-input" value="' +
        item.className +
        '" placeholder="' +
        this.translateService.instant("Form.EnterClassValue") +
        '">' +
        '<span id="class-name-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Class name required</span>' +
        "</div>" +
        `${
          this.versions.length > 0
            ? '<div style="display: flex; align-items: left;">' +
              '  <span for="_tas-ug-version" style="text-align: left; font-weight:600; font-size:16px">' +
              this.translateService.instant("Form.Version") +
              ":</span>" +
              "</div>" +
              '<div style="display: flex; align-items: left;">' +
              '  <select id="_tas-ug-version" class="swal2-select" style="width: 100%">' +
              this.versions
                .map(
                  (option) =>
                    `<option value='${option.id}' ${
                      option.id == item.projectVersion ? "selected" : ""
                    }>${option.version}</option>`
                )
                .join("") +
              "  </select>" +
              "</div>"
            : ""
        }`,
      confirmButtonText: this.translateService.instant("Form.SAVE"),
      showCancelButton: true,
      showCloseButton: true,

      customClass: {
        popup: "custom-popup-class",
        confirmButton: "swal2-confirm",
      },
      showClass: {
        popup: "animated fadeInLeft faster",
      },
      allowOutsideClick: false,
      preConfirm: () => {
        const keyInput = document.getElementById(
          "_tas-display-name"
        ) as HTMLInputElement;

        const key = keyInput.value.trim();

        const valueInput = document.getElementById(
          "_tas-class-name"
        ) as HTMLInputElement;

        const versionSelect = document.getElementById(
          "_tas-ug-version"
        ) as HTMLSelectElement;

        const projectVersion = versionSelect ? versionSelect.value : "";

        const keyError = document.getElementById("display-name-error");

        const valueError = document.getElementById("class-name-error");

        const value = valueInput.value.trim();

        let isValid = true;

        if (!key) {
          keyError.style.display = "block";
          isValid = false;
        } else {
          keyError.style.display = "none";
        }

        if (!value) {
          valueError.style.display = "block";
          isValid = false;
        } else {
          valueError.style.display = "none";
        }

        if (!isValid) {
          Swal.showValidationMessage("");
          setTimeout(() => {
            document.getElementById("swal2-validation-message").style.display =
              "none";
          });
        }

        return { key, value, projectVersion };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { key, value, projectVersion } = result.value;

        // Make API call to save the data
        this.onClickOfSaveUGEditClassButton(
          item.id,
          key,
          value,
          projectVersion
        );
      }
    });
  }

  openUserGuideClassPopup() {
    Swal.fire({
      title:
        '<div class="d-flex justify-content-between ">' +
        '<div class="pull-left" style="text-align: left;">' +
        this.translateService.instant("Form.AddClassForUserGuide") +
        "</div>" +
        "</div>",
      html:
        '<div style="display: flex;">' +
        '  <span for="_tas-display-name" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.NAME") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-display-name" class="swal2-input" placeholder="' +
        this.translateService.instant("Form.EnterNAME") +
        '">' +
        '<span id="display-name-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Display name required</span>' +
        "</div>" +
        '<div style="display: flex;">' +
        '  <span for="_tas-class-name" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.IconClassValue") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="text-align: left;">' +
        '  <input id="_tas-class-name" class="swal2-input" placeholder="' +
        this.translateService.instant("Form.EnterClassValue") +
        '">' +
        '<span id="class-name-error" style="display:none; color:red; font-size: 14px; text-align: left; margin-bottom: 25px;">Class name required</span>' +
        "</div>" +
        `${
          this.versions.length > 0
            ? '<div style="display: flex; align-items: left;">' +
              '  <span for="_tas-ug-version" style="text-align: left; font-weight:600; font-size:16px">' +
              this.translateService.instant("Form.Version") +
              ":</span>" +
              "</div>" +
              '<div style="display: flex; align-items: left;">' +
              '  <select id="_tas-ug-version" class="swal2-select" style="width: 100%">' +
              this.versions
                .map(
                  (option) =>
                    `<option value='${option.id}'>${option.version}</option>`
                )
                .join("") +
              "  </select>" +
              "</div>"
            : ""
        }`,
      confirmButtonText: this.translateService.instant("Form.SAVE"),
      showCancelButton: true,
      showCloseButton: true,

      customClass: {
        popup: "custom-popup-class",
        confirmButton: "swal2-confirm",
        closeButton: "custom-swal-close",
      },
      showClass: {
        popup: "animated fadeInLeft faster",
      },
      allowOutsideClick: false,
      preConfirm: () => {
        const keyInput = document.getElementById(
          "_tas-display-name"
        ) as HTMLInputElement;

        const key = keyInput.value.trim();

        const valueInput = document.getElementById(
          "_tas-class-name"
        ) as HTMLInputElement;

        const versionSelect = document.getElementById(
          "_tas-ug-version"
        ) as HTMLSelectElement;

        const projectVersion = versionSelect ? versionSelect.value : "";

        const keyError = document.getElementById("display-name-error");

        const valueError = document.getElementById("class-name-error");

        const value = valueInput.value.trim();

        let isValid = true;

        if (!key) {
          keyError.style.display = "block";
          isValid = false;
        } else {
          keyError.style.display = "none";
        }

        if (!value) {
          valueError.style.display = "block";
          isValid = false;
        } else {
          valueError.style.display = "none";
        }

        if (!isValid) {
          Swal.showValidationMessage("");
          setTimeout(() => {
            document.getElementById("swal2-validation-message").style.display =
              "none";
          });
        }

        return { key, value, projectVersion };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { key, value, projectVersion } = result.value;

        // Make API call to save the data
        this.onClickOfSaveUGClassButton(key, value, projectVersion);
      }
    });
  }

  openPopup() {
    Swal.fire({
      title:
        '<div class="d-flex justify-content-between ">' +
        '<div class="pull-left" style="text-align: left;">' +
        this.translateService.instant("Form.AddVersion") +
        "</div>" +
        "</div>",
      html:
        '<div style="display: flex;">' +
        '  <span for="version" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.Version") +
        ':<span class="text-danger">*</span></span>' +
        "</div>" +
        '<div style="display: flex; text-align: left;">' +
        '  <input id="version" class="swal2-input" placeholder="' +
        this.translateService.instant("Form.EnterVersion") +
        '">' +
        "</div>" +
        '<div style="display: flex;">' +
        '  <span for="releaseDate" style="text-align: left; font-weight:600; font-size:16px">' +
        this.translateService.instant("Form.ReleaseDate") +
        ":</span>" +
        "</div>" +
        '<div style="display: flex; text-align: left;">' +
        '  <input id="releaseDate" placeholder="DD/MM/YYYY" class="swal2-input" type="date">' +
        "</div>" +
        `${
          this.versions.length > 0
            ? '<div style="display: flex; align-items: left;">' +
              '  <span for="baseVersion" style="text-align: left; font-weight:600; font-size:16px">' +
              this.translateService.instant("Form.BaseVersion") +
              ":</span>" +
              "</div>" +
              '<div style="display: flex; align-items: left;">' +
              '  <select id="baseVersion" class="swal2-select" style="width: 100%">' +
              "<option value=''>" +
              this.translateService.instant("Form.SelectBaseVersion") +
              "</option>" +
              this.versions
                .map((option) => `<option>${option.version}</option>`)
                .join("") +
              "  </select>" +
              "</div>" +
              '<div style="display: flex; width: 100%; align-items: center; margin-bottom:0.7rem;">' +
              '  <input type="checkbox" id="copyFromDev" style="margin-right: 10px;">' +
              '  <label for="copyFromDev" style="margin-bottom:0.2rem;">' +
              this.translateService.instant("Form.Copyfromdev") +
              "</label>" +
              "</div>" +
              '<div style="display: flex; width: 100%; align-items: center; margin-bottom:0.7rem;">' +
              '  <input type="checkbox" id="copyFromQA" style="margin-right: 10px;">' +
              '  <label for="copyFromQA" style="margin-bottom:0.2rem;">' +
              this.translateService.instant("Form.CopyfromQA") +
              "</label>" +
              "</div>" +
              '<div style="display: flex; width: 100%; align-items: center;">' +
              '  <input type="checkbox" id="copyFromProd" style="margin-right: 10px;" checked disabled>' +
              '  <label for="copyFromProd" style="margin-bottom:0.2rem;">' +
              this.translateService.instant("Form.CopyfromProd") +
              "</label>" +
              "</div>"
            : ""
        }`,
      confirmButtonText: this.translateService.instant("Form.SAVE"),
      showCancelButton: true,
      showCloseButton: true,

      customClass: {
        popup: "custom-popup-class",
        confirmButton: "swal2-confirm",
      },
      showClass: {
        popup: "animated fadeInLeft faster",
      },
      allowOutsideClick: false,
      preConfirm: () => {
        const versionInput = document.getElementById(
          "version"
        ) as HTMLInputElement;
        const releaseDateSelect = document.getElementById(
          "releaseDate"
        ) as HTMLSelectElement;
        const baseVersionSelect = document.getElementById(
          "baseVersion"
        ) as HTMLSelectElement;
        const copyFromDevCheckbox = document.getElementById(
          "copyFromDev"
        ) as HTMLInputElement;
        const copyFromQACheckbox = document.getElementById(
          "copyFromQA"
        ) as HTMLInputElement;

        const version = versionInput.value.trim();
        const releaseDate = releaseDateSelect ? releaseDateSelect.value : null;
        const baseVersion = baseVersionSelect ? baseVersionSelect.value : "";
        const copyFromDev = copyFromDevCheckbox
          ? copyFromDevCheckbox.checked
          : false;
        const copyFromQA = copyFromQACheckbox
          ? copyFromQACheckbox.checked
          : false;

        if (!version) {
          Swal.showValidationMessage(
            this.translateService.instant("Form.Versionrequired")
          );
        }

        return { version, copyFromDev, copyFromQA, baseVersion, releaseDate };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { version, copyFromDev, copyFromQA, baseVersion, releaseDate } =
          result.value;

        // Make API call to save the data
        this.onClickOfSaveVersionButton(
          version,
          copyFromDev,
          copyFromQA,
          releaseDate,
          baseVersion
        );
      }
    });
    const copyFromDevCheckbox = document.getElementById(
      "copyFromDev"
    ) as HTMLInputElement;
    const copyFromQACheckbox = document.getElementById(
      "copyFromQA"
    ) as HTMLInputElement;

    copyFromDevCheckbox.addEventListener("change", () => {
      if (copyFromDevCheckbox.checked) {
        copyFromQACheckbox.checked = true;
      } else {
        copyFromQACheckbox.checked = false;
      }
    });
  }

  deletVersion(item) {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      panelClass: "custom-bg",
      data: {
        title: "Delete Version",
        paragraph: `This will delete all tooltips, workflows, FAQs and user guide of this version
                      Are you sure you want to delete this version?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      var payload = item;
      if (result) {
        this.crudService.update(
          payload,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Version has been deleted successfully.",
                "Success"
              );
              this.ngOnInit();
              this.getVersions(item.projectManagementId);
            }
          },
          "Versions/deleteVersion"
        );
      }
    });
  }

  deleteClass(item) {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      panelClass: "custom-bg",
      data: {
        title: "Delete Class",
        paragraph: `Are you sure you want to delete this class?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Class has been deleted successfully.",
                "Success"
              );
              this.getUgClass(item.projectManagementId, this.selectedVersion);
            }
          },
          "userGuideClasses/" + item.id
        );
      }
    });
  }

  deleteVariable(item) {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      panelClass: "custom-bg",
      data: {
        title: "Delete Variable",
        paragraph: `Are you sure you want to delete this variable?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Variable has been deleted successfully.",
                "Success"
              );
              this.getVariables(item.projectManagementId, this.selectedVersion);
            }
          },
          "variables/" + item.id
        );
      }
    });
  }

  @HostListener("window:beforeunload")
  canDeactivate() {
    if (
      this.form.dirty ||
      this.globalConfigForm.dirty ||
      this.workflowConfigForm.dirty ||
      this.tooltipConfigForm.dirty ||
      this.languageConfigForm.dirty ||
      this.commonIconConfig.dirty
    ) {
      const modalRef = this.modalService.open(DeactiveConfirmComponent, {
        backdrop: "static",
        centered: true,
      });

      return modalRef.result;
    }

    return true;
  }
  async getRole(projectid, selectedVersion) {
    let self = this;
    let query = `filter[where][projectManagementId]=${projectid}&[version]=${selectedVersion}`;
    self.crudService.get(
      null,
      function (response) {
        if (response) {
          self.appRolesdetail = response;
        }
      },
      "appRoles?" + query
    );
  }
  openRolePopup(content) {
    this.roleForm.reset();
    this.roleForm.clearValidators();
    this.roleForm.updateValueAndValidity(); /* forces Angular to refresh the state and make sure the form isn’t stuck in an old validation state */
    this.roleData = null;
    this.modalRef = this.modalService.open(content);
  }
  openEditRolePopup(content, item) {
    let self = this;
    this.roleData = item;
    this.crudService.get(
      null,
      function (response) {
        if (response) {
          self.roleForm.get("displayname").setValue(response["displayname"]);
          self.roleForm.get("name").setValue(response["name"]);
        }
      },
      "appRoles/" + item.id
    );
    this.modalRef = this.modalService.open(content);
  }
  async onRoleSubmit() {
    var self = this;
    var payload;
    payload = this.roleForm.value;

    if (!this.roleData) {
      payload["projectManagementId"] = this.currentProject.id;
      payload["version"] = this.selectedVersion;
      // payload["companyId"] = this.projectId;
      this.crudService.post(
        payload,
        async function (response) {
          if (response) {
            self.modalService.dismissAll();
            self.toastr.clear();
            self.toastr.success("Successfully added the role!");
            await self.getRole(self.currentProject.id, self.selectedVersion);
            self.ngOnInit();
          } else if (response.error) {
            // this.modalService.dismissAll();
            self.toastr.clear();
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            // console.log("rejected ", reject);
          }
        },
        "appRoles"
      );
    } else {
      this.crudService.update(
        payload,
        async function (response) {
          if (response.error) {
            // this.modalService.dismissAll();
            self.toastr.clear();
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            // console.log("rejected ", reject);
          } else if (response && !response.error) {
            self.modalService.dismissAll();
            self.toastr.clear();
            self.toastr.success("Successfully updated the role!");
            self.cdr.detectChanges();
            await self.getRole(self.currentProject.id, self.selectedVersion);
            self.ngOnInit();
          }
        },
        "appRoles/" + this.roleData.id
      );
    }
  }
  // Handle the cancel action
  cancel(modal: any) {
    // Close the modal on cancel
    modal.dismiss("Cancel");
  }
  deleteRole(item) {
    // let payload = item;
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      panelClass: "custom-bg",
      data: {
        title: "Delete Role",
        paragraph: `Are you sure you want to delete this role?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Role has been deleted successfully.",
                "Success"
              );

              this.getRole(item.projectManagementId, this.selectedVersion);
              this.ngOnInit();
            }
          },
          "appRoles/" + item.id
        );
      }
    });
    this.cdr.detectChanges();
  }

  noSpacesOrSpecialCharsValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbiddenPattern = /[^a-zA-Z0-9-_]/; // Regex that matches any character other than alphanumeric
      if (control.value && forbiddenPattern.test(control.value)) {
        return { noSpacesOrSpecialChars: true }; // Return an error if it contains space or special chars
      }
      return null; // Return null if valid
    };
  }
  async addLogstoFile(xhr, extrainfo) {
    var data = {};

    if (xhr.responseText) {
      data["error"] = xhr.responseText;
    } else {
      data["error"] = xhr;
    }
    data["extraInfo"] = extrainfo;
    var payload = data;
    this.crudService.update(
      payload,
      function (response) {},
      "logErrors/addErrorToFile"
    );
  }
}
